import React, { Component } from "react";
import { style } from "typestyle";

interface Props {
  value: string;
  name: string;
  onAddText: (text: string) => void;
  placeholder: string;
}

interface State {
  value: string;
  hasError: boolean;
}

export default class TextInput extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: this.props.value,
      hasError: false,
    };
  }

  handleChange = (event: any) => {
    this.setState({ value: event.target.value });
  };

  handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.handleAddText(this.state.value);
    }
  };

  handleAddText = (text: string) => {
    if (this.validate(text)) {
      this.props.onAddText(text);
      this.setState({
        value: "",
        hasError: false,
      });
      return;
    }
    this.setState({ hasError: true });
  };

  validate = (text: string): boolean => {
    const emailTest = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return !!text && emailTest.test(text.toLowerCase());
  };

  render() {
    return (
      <input
        className={textInputCN(this.state.hasError)}
        type="text"
        placeholder={this.props.placeholder}
        name={this.props.name}
        value={this.state.value}
        onKeyPress={this.handleKeyPress}
        onChange={this.handleChange}
      />
    );
  }
}

const textInputCN = (hasError: boolean = false) =>
  style({
    boxShadow:
      "0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12)",
    borderRadius: "2px",
    padding: "24px",
    lineHeight: "24px",
    border: "none",
    fontSize: "20px",
    width: "391px",
    display: "flex",
    flexDirection: "row",
    background: hasError ? "#eacccc" : "none",
  });
